import React from "react"
import PropTypes from "prop-types"
import { SearchInput } from "components"
import { Radium } from "higher-order-components"
import COLOR_PALETTE from "constants/color-palette"

const width = "4em"

const GlobalNavSearchFieldSlider = ({
  open = false,
  onOpen,
  placeholderText = "What are you looking for?",
  innerInputRef,
  onSlideEnd,
  ...props
}) => (
  <div
    style={{
      display: "inline-block",
      marginRight: width
    }}>
    <div
      style={styles.drawer(open)}
      onTransitionEnd={(e) => {
        // Multiple transitionEnd event's fired. The drawer animation is a transform.
        if (e.propertyName === "transform") {
          onSlideEnd(e, open)
        }
      }}>
      <div
        style={{
          display: "flex",
          height: "100%",
          boxSizing: "border-box",
          alignItems: "center",
          fontSize: "110%",
          padding: "0 2em .5em .5em"
        }}>
        <SearchInput
          innerRef={innerInputRef}
          onSearchIconClick={onOpen}
          lineColor={COLOR_PALETTE.GRAY_DARKER}
          focusStyle={false}
          behaviour={"close"}
          styleName={"dark"}
          icon={"cross"}
          type={"text"}
          fadeOutInput={!open}
          placeholder={placeholderText}
          {...props} />
      </div>
    </div>
  </div>
)

GlobalNavSearchFieldSlider.propTypes = {
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  placeholderText: PropTypes.string,
  searchPageUrl: PropTypes.string,
  innerInputRef: PropTypes.func
}

export default Radium(GlobalNavSearchFieldSlider)

const styles = {
  drawer: open => ({
    position: "absolute",
    backgroundColor: COLOR_PALETTE.BLACK,
    right: 0,
    top: 0,
    bottom: 0,
    left: "1em",
    transition: `transform 1s ${open ? 0 : 0.5}s`,
    transform: open ? "translateX(0)" : `translateX(100%) translateX(-${width})`
  }),
  searchWrapper: {
    height: "1.25em",
    width: "1.25em",
    cursor: "pointer",
    verticalAlign: "middle",
    transition: ".25s",
    color: COLOR_PALETTE.GRAY_DARK,
    ":hover": {
      color: COLOR_PALETTE.WHITE,
      outline: 0
    }
  },
  searchSvg: {
    width: "100%",
    height: "100%",
    fill: "currentColor",
    display: "inline-block"
  }
}



// WEBPACK FOOTER //
// ./src/containers/global-nav-search/search-field-slider.jsx